import { render, staticRenderFns } from "./AppSkeleton.vue?vue&type=template&id=7564adbe&scoped=true"
import script from "./AppSkeleton.vue?vue&type=script&lang=js"
export * from "./AppSkeleton.vue?vue&type=script&lang=js"
import style0 from "./AppSkeleton.vue?vue&type=style&index=0&id=7564adbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7564adbe",
  null
  
)

export default component.exports